import { TValueOf } from '@skillarea/lib-shared';

export const ESizes = {
  s: 's',
  m: 'm',
  l: 'l',
} as const;

export const ESizesExtendedEnum = {
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl',
} as const;

export type TSizes = TValueOf<typeof ESizes>;
export type TSizesExtended = TValueOf<typeof ESizesExtendedEnum>;
